/* ══════════════════════════════════════════════════════════════════
   [D-768] «👆 Переходи в наші застосунки» — у картці юзера.

   OWNER 30.10: «чомусь я так і не бачу у списку юзерів Андрія входи у
   застосунки». Досі переходи були лише двома ЗВЕДЕНИМИ списками — у картці
   партнера (D-548) і на сторінці «Наші APP» (D-767). У самого юзера їх не
   було ніде: відкривши людину, власник не бачив ані що вона заходила, ані
   куди. Тут — її власні переходи: у що, скільки разів і звідки прийшла.

   Блок мовчить, коли переходів немає: порожня рамка в картці юзера нікому
   нічого не каже, а картка й так довга.
   ══════════════════════════════════════════════════════════════════ */
import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import api from '../api';
import { srcLabel, srcLine } from './appClickSrc';

const C = { card: '#1b2836', line: 'rgba(0,229,160,.22)', txt: '#eaf6ff', dim: '#a8bece', neon: '#00e5a0' };
const fdt = (v) => (v ? new Date(v).toLocaleString('uk-UA', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—');

export default function UserAppClicks({ userId }) {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    let dead = false; setD(null);
    api.get(`/users/${userId}/app-clicks`).then(r => { if (!dead) setD(r.data); }).catch(() => { if (!dead) setD({ total: 0, apps: [], last: [] }); });
    return () => { dead = true; };
  }, [userId]);
  if (!d || !d.total) return null;
  return (
    <Box data-uac="box" sx={{ mb: 2, p: 1.4, borderRadius: 2, border: `1px solid ${C.line}`, bgcolor: 'rgba(0,229,160,.04)' }}>
      <Box onClick={() => setOpen(!open)} sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', cursor: 'pointer' }}>
        <Typography data-uac="sum" sx={{ color: C.txt, fontWeight: 800, fontSize: 14.5, flex: 1, minWidth: 200 }}>
          👆 Переходи в наші застосунки: {d.total}
          <span style={{ color: C.dim, fontWeight: 600, fontSize: 12.5 }}>
            {' '}· відкривав {d.opens} · презентацію {d.previews}
          </span>
        </Typography>
        <Typography sx={{ color: C.dim, fontSize: 12.5 }}>{open ? 'згорнути' : 'показати кожен'}</Typography>
      </Box>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: .8, mt: 1 }}>
        {d.apps.map(a => (
          <Box key={a.key} data-uac-app={a.key} sx={{ px: 1, py: .6, borderRadius: 2, bgcolor: C.card, border: '1px solid rgba(255,255,255,.08)' }}>
            <Typography sx={{ fontSize: 13, color: C.txt, fontWeight: 700 }}>
              {a.icon} {a.title}
              {a.opens ? <b style={{ color: C.neon }}> ×{a.opens}</b> : null}
              {a.previews ? <span style={{ color: C.dim }}> · 👁 {a.previews}</span> : null}
            </Typography>
            <Typography sx={{ fontSize: 11.5, color: C.dim }}>📍 {srcLine(a.srcs)} · востаннє {fdt(a.last)}</Typography>
          </Box>
        ))}
      </Box>
      {open && (
        <Box sx={{ mt: 1.2 }}>
          {d.last.map((x, i) => (
            <Typography key={i} data-uac-row={i} sx={{ fontSize: 12.5, color: C.dim, py: .25, borderTop: i ? '1px solid rgba(255,255,255,.06)' : 'none' }}>
              {fdt(x.at)} · <span style={{ color: C.txt }}>{x.icon} {x.app}</span> · {x.kind === 'preview' ? '👁 презентація' : '🚀 відкрив'} · 📍 {srcLabel(x.src)}
            </Typography>
          ))}
          <Typography sx={{ fontSize: 11.5, color: C.dim, mt: .8 }}>
            Показано останні {d.last.length}. Ті самі події приходять у гілку «👆 Переходи в застосунки», зведення по всіх людях — на сторінці «📱 Наші APP».
          </Typography>
        </Box>
      )}
    </Box>
  );
}
